import styled from 'styled-components';
import { grey700 } from '../../../../../design/colors/greyscale';
import { BodyP } from '../../../../../design/typography/Typography';

export const SectionSubText = styled(BodyP)`
  color: ${grey700};
`;
SectionSubText.defaultProps = { type: 'bodySRegular' };
